export default __webpack_public_path__ + "static/media/light_02_white.14428af2.svg";